import axios from "axios";
import { CREATE_INVOICE, SEND_PAYMENT } from "../api";

export const createInvoice = async (data) => {
  try {
    const response = await axios.post(CREATE_INVOICE, data);
    return response
  } catch (error) {
    console.error(`Error creating invoice: ${error}`);
    throw error
  }
};
export const sendPayment = async (data) => {
  try {
    const response = await axios.post(SEND_PAYMENT, data);
    if (response.status != 201) {
      throw new Error("Something went wrong.");
    }
    return response;
  } catch (error) {
    console.error(`Error sending payment: ${error}`);
    throw error;
  }
};